import { useEffect } from 'react';
import { useDataTable } from '../../../../common/hooks';
import { useRef } from 'react';
import customHeaders, { getSpace } from '../../../../common/headers';
import useGeneralStore from '../../../../store/general';
import { TableBox } from '@lk-gtcom/ecomlab-components';
import { ModalComponent } from '../../../../components/Modal/ModalComponent/ModalComponent';
import { useResponseHandler } from '../../../../common/auth';
import './ModalHistoryChangesTasks.scss'

const ModalHistoryChangesTasks = ({
    setIsModal,
    currentTask
}) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleTableResponse, handleRequestError } = useResponseHandler();
    const refContainer = useRef()

    // Таблица
    const paginatorRef = useRef();
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    );
    const { setLoading } = setTableFuncs;

    // Таблица задач
    const fetchTableData = (params, abortController = new AbortController()) => {
        let sort
        let filtersParam

        if (params) {
            [sort, filtersParam] = params
        }

        setLoading(true)

        let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/audit-table${sort?.length > 0
            ? '?order_param=' + sort[0] + '&order_direction=' + sort[1]
            : ''}`

        const body = JSON.stringify({
            limit: paginatorRef?.current?.limit,
            page: paginatorRef?.current?.page,
            filters: filtersParam,
            task_id: currentTask
        })

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then(json => setTable(json))
            .catch(handleRequestError)
            .finally(() => {
                if (abortController.signal.aborted) return
                setLoading(false)
            })

    }

    useEffect(() => {
        const abortController = new AbortController();
        fetchTableData([], abortController)
        return () => abortController.abort();
    }, [currentTask]);

    return (
        <ModalComponent
            onClose={e => setIsModal(false)}
            title={`История изменений в задаче ID-${currentTask || '-'}`}
            child={
                <div
                    className='modal-history-changes-tasks'
                    ref={refContainer}
                >
                    <TableBox
                        ref={paginatorRef}
                        refContainer={refContainer}
                        paginator={true}
                        {...tableProps}
                        fetchCallback={fetchTableData}
                    />
                </div>}
        />

    )
}

export { ModalHistoryChangesTasks }